/* global $ */
// eslint-disable-next-line no-unused-vars
import slick from 'slick-carousel';
import throttle from 'lodash.throttle';

class PracticePage {
  constructor() {
    this.$window = $(window);
    this.$practiceStatements = $('.js-practice-statements');
    this.$practiceSplitImageContainer = $('.js-practice-split-image');
    this.$splitImages = $('.js-split-image');
    this.$splitImageHolders = $('.js-split-image-holder');
    this.containerY;

    if ((location.pathname === ('/practice/')) || location.pathname === ('/zh/practice/')) {
      this.init();
    }
  }

  init() {
    this.initializeImageClip();
    this.$practiceStatements.slick({
      autoplaySpeed: 2000,
      dots: true,
      arrows: false,
      autoplay: true,
      draggable: false,
      infinite: true,
      slidesToShow: 1,
      adaptiveHeight: false,
    });
    this.$window.on('resize.practice orientationchange.practice', () => {
      this.$practiceStatements.slick('refresh');
    });
    this.$practiceSplitImageContainer.on('mousemove.practice', throttle(this.showImageOnHover, 20).bind(this));
    this.$window.on('scroll.practice', throttle(this.onScroll, 16).bind(this));
  }

  initializeImageClip() {
    this.containerY = this.$practiceSplitImageContainer.position().top;
    this.$splitImageHolders.each((i, el) => {
      const imageSrc = $(el).attr('src');
      const $splitImage = this.$splitImages.eq(i);
      $splitImage.css('background-image', `url(${imageSrc})`);
    })
  }

  onScroll() {
    const scrollY = $(document).scrollTop();
    const percentage = (scrollY / this.containerY) * 100;

    this.changeImageHover(percentage);
  }

  showImageOnHover(evt) {
    const cursorOffset = evt.pageX - this.$practiceSplitImageContainer.offset().left;
    const containerWidth = this.$practiceSplitImageContainer.width();
    const percentage = (cursorOffset / containerWidth) * 100;

    this.changeImageHover(percentage);
  }

  changeImageHover(percentage) {
    this.$splitImages.eq(0).css({
      'clip-path': `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)`,
      '-webkit-clip-path': `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)`
    });
    this.$splitImages.eq(1).css({
      'clip-path': `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`,
      '-webkit-clip-path': `polygon(${percentage}% 0, 100% 0, 100% 100%, ${percentage}% 100%)`,
    });
  }

  deinit() {
    this.$practiceStatements.slick('unslick');
    this.$practiceSplitImageContainer.off('mousemove.practice');
    this.$window.off('scroll.practice resize.practice orientationchange.practice');
  }
}

export default PracticePage;
